import { c as _c } from "react/compiler-runtime";
import { useCallback, useState } from 'react';
const useToggle = t0 => {
  const $ = _c(4);
  const initialValue = t0 === undefined ? false : t0;
  const [value, setValue] = useState(initialValue);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setValue(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggleOn = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setValue(false);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const toggleOff = t2;
  let t3;
  if ($[2] !== value) {
    t3 = [value, toggleOn, toggleOff];
    $[2] = value;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3 as const;
};
export default useToggle;